import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Observable } from 'rxjs';

/** Constants */
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';

// Replace the RxJS debounce implementation with a timeout-based approach
let timeoutId: any = null;
const pendingRequests: { req: any; next: any }[] = [];

const executeRequest = (req: any, next: any) => {
  return next(req);
};

const handleDebouncedRequest = () => {
  if (pendingRequests.length > 0) {
    const { req, next } = pendingRequests[pendingRequests.length - 1];
    pendingRequests.length = 0;
    return executeRequest(req, next);
  }
  return null;
};

export const apiPrefixInterceptor: HttpInterceptorFn = (req, next) => {
  const authService = inject(AuthService);
  let idToken = null;
  authService.idToken$.subscribe((token) => {
    if (token !== null && token !== '') {
      idToken = token;
    }
  });
  if (req.url.startsWith('./assets/i18n/')) return next(req);

  if (!req.url.includes('http:') && !req.url.includes('https:')) {
    if (idToken) {
      req = req.clone({
        url: environment.apiConfig.baseApiUrl + req.url,
        setHeaders: {
          Authorization: `Bearer ${idToken}`,
        },
      });
    } else {
      req = req.clone({
        url: environment.apiConfig.baseApiUrl + req.url,
      });
    }

    const xFilterHeader = req.headers.get('X-filter');
    if (xFilterHeader) {
      try {
        const filterData = JSON.parse(xFilterHeader);
        // Debounce only if pagination fields are present
        // if (
        //   typeof filterData.currentPage === 'number' &&
        //   typeof filterData.pagingSize === 'number'
        // ) {
        //   // Debounce pagination requests for 2 seconds
        //   return new Observable((observer) => {
        //     if (timeoutId) {
        //       clearTimeout(timeoutId);
        //     }

        //     pendingRequests.push({ req, next });

        //     timeoutId = setTimeout(() => {
        //       const result = handleDebouncedRequest();
        //       if (result) {
        //         result.subscribe(observer);
        //       }
        //     }, 2000); // 2 seconds debounce for pagination
        //   });
        // } else

        if (filterData.searchKeyWord) {
          // Optionally, keep the old debounce for search if needed (300ms)
          return new Observable((observer) => {
            if (timeoutId) {
              clearTimeout(timeoutId);
            }

            pendingRequests.push({ req, next });

            timeoutId = setTimeout(() => {
              const result = handleDebouncedRequest();
              if (result) {
                result.subscribe(observer);
              }
            }, 300); // 300ms debounce for search
          });
        }
      } catch (e) {}
    }
  }

  return next(req);
};
